import { client } from "api";
import { Company } from "models/Company";
import { CompanyOffice } from "models/CompanyOffice";

export type GetOfficesRequest = { companyId: Company["id"] };

export type GetOfficesResponse = CompanyOffice[];

export const getOffices = ({ companyId }: GetOfficesRequest) =>
  client.get<GetOfficesResponse>(`/company/${companyId}/offices`).then((res) => res.data);
